import { Divider, ListTitle } from "@components"
import { ChevronRightIcon } from "@heroicons/react/24/outline"
import PropTypes from 'prop-types'

const ListLink = ({ 
  description, 
  handleClick = () => {},
  icon,
  iconColor = "text-gray-600",
  showDivider = true, 
  title 
}) => (
  <section className="cursor-pointer" onClick={handleClick}>
    <div className="flex items-center justify-between">
      <ListTitle description={description} icon={icon} iconColor={iconColor} title={title} />
      <ChevronRightIcon className="w-8 h-8 text-gray-400" />
    </div>
    
    {showDivider && <Divider className="my-4" />}
  </section>
)

ListLink.propTypes = {
  description: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  icon: PropTypes.object.isRequired,
  iconColor: PropTypes.string,
  showDivider: PropTypes.bool,
  title: PropTypes.string.isRequired
}

export default ListLink